import type { TPSPrintRequest } from "@/types/printer";

/**
 * A print request carrying the copies the API asked for (bill: Print Preferences
 * "Bill copies"; KOT: Kitchen settings KOT copies). The print service repeats the
 * job; every copy ends with its own paper cut. One copy leaves the request as is.
 */
export function withCopies(request: TPSPrintRequest, copies: number | null | undefined): TPSPrintRequest {
  const n = Math.floor(Number(copies) || 1);
  return n > 1 ? { ...request, copies: Math.min(n, 10) } : request;
}
